<template>
  <v-content class="full-height">
    <form-alert
      :type="alertText.type"
      :message="alertText.message"
      @close="closeFormAlert"
    />

    <v-container fluid grid-list-xl id="detalhar-tomador" v-if="loaded">
      <v-layout row wrap>
        <v-flex xs12>
          <div class>
            <a class @click="$router.push({ path: '/tomadores' })">
              <span class="font-weight-black subheading">
                <v-icon color="black">arrow_back</v-icon>Voltar
              </span>
            </a>
          </div>
        </v-flex>

        <v-flex v-for="tab in tabs" :key="tab.path" mr-3>
          <button
            class="blue-button inverted tab-button mb-4"
            v-html="tab.name"
            :class="{ active: tab.path == activeTab }"
            @click="changeTab(tab.path)"
          ></button>
        </v-flex>

        <v-flex xs12>
          <tomador-dados-gerais
            :taker="taker"
            v-if="activeTab == 'dados-gerais' && taker"
            @update-taker="updateTaker"
          />

          <tomador-limites-taxas
            :idTomador="taker.id"
            v-if="activeTab == 'limites-taxas'"
          />
          <tomador-participantes
            :participantes="
              activeTab == 'consorcio'
                ? taker.participantes_consorcio
                : economicGroup
            "
            v-if="activeTab == 'consorcio' || activeTab == 'grupo-economico'"
          />

          <tomador-ccg
            v-if="activeTab == 'contra-garantia' && ccg"
            @save="getCCGPeople"
            :id-tomador="takerCNPJ"
            :documentosCcg="documentosCcg"
          />

          <tomador-documentos
            v-if="activeTab == 'revisao-credito'"
            :documentosSolicitados="taker.documentos"
            :documentosPreenchidos="taker.documentos_preenchidos"
            :id-tomador="taker.id"
            :cadastroRevisado="taker.cadastro_revisado"
            @update="updateTaker"
          />

          <tomador-acompanhamento
            v-if="activeTab == 'acompanhamento'"
            :acompanhamento="taker.acompanhamento"
            :id-tomador="taker.id"
          />

          <tomador-apolice
            v-if="activeTab == 'apolices'"
            :pages="pages"
            :policies="apolices"
            :id-tomador="taker.id"
            :cnpj-tomador="takerCNPJ"
            :filtros="filtros"
          />
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="statusNomeado" :max-width="'640'">
      <base-modal>
        <h2 class="title">Atenção</h2>
        <p class="description">
          Tomador já possui corretor nomeado, favor inserir a Carta de Nomeação
        </p>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="redirectTomadores"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </v-content>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
export default {
  name: "TomadorListar",
  mixins: [ViewMixin],
  data: () => ({
    searchFilter: {
      generalSearch: "",
    },
    statusNomeado: false,
    taker: [],
    generalSearch: "",
    initTab: "",
    corretores: false,
    search: "",
    loaded: false,
    loading: false,
    pagination: {},
    pages:[],
    takerCNPJ: false,
    tab: false,
    activeTab: false,
    limits: false,
    apolices: [],
    filtros: [],
    documentosCcg: [],
    economicGroup: [],
    limitsFees: [],

    tabs: [
      { name: "Dados Gerais", path: "dados-gerais" },
      { name: "Limites/Taxas", path: "limites-taxas" },
      { name: "Contra-Garantia", path: "contra-garantia" },
      { name: "Revisão de Crédito", path: "revisao-credito" },
      { name: "Acompanhamento", path: "acompanhamento" },
      { name: "Apólices", path: "apolices" },
    ],
  }),
  computed: {
    ccg() {
      return this.$store.state.ccg || false;
    },
  },
  methods: {
    init() {
      this.showLoadingAskWait();
      let promises = [this.getTakerByCNPJ(), this.getCCGPeople(), this.getFiltersApolices(), this.getCCGDocumento(), this.getEconomicGroup()];
      Promise.all(promises).then(() => {
        this.hideLoadingAskWait();
        this.generateTabs();
        this.setActiveTab();
        this.loaded = true;
      });
      this.getApolicesPeopleByCNPJ();
    },

    generateTabs() {
      this.tabs = [
        { name: "Dados Gerais", path: "dados-gerais" },
        { name: "Limites/Taxas", path: "limites-taxas" },
        { name: "Contra-Garantia", path: "contra-garantia" },
        { name: "Revisão de Crédito", path: "revisao-credito" },
        { name: "Acompanhamento", path: "acompanhamento" },
        { name: "Apólices", path: "apolices" },
      ];

      //tabs adicionadas conforme dados retornados da API
      if (this.taker.tipo_pessoa.toUpperCase() == "CONSORCIO") {
        this.tabs.push({ name: "Consórcio / SPE", path: "CONSORCIO" });
      }

      // Alteração da condição para a nova consulta getEconomicGroup()
      if (this.economicGroup.length){
        this.tabs.push({ name: "Grupo Econômico", path: "grupo-economico" });
      }
    },

    setActiveTab() {
      // Aqui define qual das tabs vai ficar ativa

      if (this.initTab) {
        this.activeTab = this.initTab
        return
      }

      switch (this.tab) {
        case '1':
          this.activeTab = "dados-gerais";
          break;
        case '2':
          this.activeTab = "limites-taxas";
          break;
        case '3':
          this.activeTab = "contra-garantia";
          break;
        case '4':
          this.activeTab = "revisao-credito";
          break;
        case '5':
          this.activeTab = "acompanhamento";
          break;
        case '6':
          this.activeTab = "consorcio";
          break;
        case '7':
          this.activeTab = "grupo-economico";
          break;
        case '8':
          this.activeTab = "apolices";
          break;
        default:
          this.activeTab = "dados-gerais"
          break;
      }
    },

    validateStatusNomeado() {
      if (this.taker.status_nomeado == "OUTRO_NOMEADO") {
        this.statusNomeado = true;
      }
    },

    redirectTomadores() {
      this.$router.push({ path: "/tomadores" });
    },

    // Ação compartilhada entre os componentes da store (GET_TAKER_BY_CNPJ)
    async getTakerByCNPJ() {
      let takerCNPJ = this.takerCNPJ;
      try {
        this.taker = await this.$store.dispatch("GET_TAKER_BY_CNPJ", { takerCNPJ ,});
      } catch (e) {
        console.warn(e);
      }



    },

    async getLimitsByCNPJ() {
      let takerCNPJ = this.takerCNPJ;
      try {
        this.limits = await this.$store.dispatch("GET_TAKER_LIMITS_BY_CNPJ", {
          takerCNPJ,
        });
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    async getCCGPeople() {
      try {
        this.showLoadingAskWait();
        await this.$store.dispatch("GET_CCG_PEOPLE", {
          documento: this.takerCNPJ,
        });
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    async getApolicesPeopleByCNPJ() {
      let takerCNPJ = this.takerCNPJ;
      try {
        //dados da páginação e as propostas
        let {page, apolices} = await this.$store.dispatch("GET_TAKER_APOLICES", {
          cnpj: takerCNPJ,
          pagina_atual: 1
        });
        this.pages = page;
        this.apolices = apolices;
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    async getFiltersApolices() {
      let takerCNPJ = this.takerCNPJ;
      try {
        this.filtros = await this.$store.dispatch("GET_FILTERS_APOLICES", {
          cnpj: takerCNPJ,
        });
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    async getCCGDocumento() {
      let takerCNPJ = this.takerCNPJ;
      try {
        this.documentosCcg = await this.$store.dispatch("GET_CCG_DOCUMENTO", {
          cnpj: takerCNPJ,
        });
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    async getEconomicGroup() {
      let takerCNPJ = this.takerCNPJ;
      try {
        this.economicGroup = await this.$store.dispatch("GET_GRUPO_ECONOMICO", {
          cnpj_cpf: takerCNPJ,
        });
        this.$forceUpdate();
      } catch (e) {
        console.warn(e);
      } finally {
      }
    },

    updateTaker(taker) {
      this.taker = taker;
      this.changeTab("dados-gerais");
      this.$forceUpdate();
    },

    changeTab(path) {
      this.activeTab = path;
    },
  },

  mounted() {
    //Dados carregados da rota e funções que são executadas conforme inicia o sistema
    // console.log("ROUTE", window.location.href)
    // const params = new URLSearchParams(window.location.search)
    const tab = this.$route.query.tab
    this.initTab = tab
    this.alert = this.handleAlertText();
    this.takerCNPJ = this.$route.params.takerCNPJ;
    this.tab = this.$route.params.tab;
    this.init();
    this.validateStatusNomeado();
  },

  destroyed() {
    this.$store.commit("SET_CCG", []);
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ./src/router/views/Tomadores/Detalhar.vue